export default "__VITE_ASSET__uo6_$bOD__"